import { useCallback, useMemo, useState } from "react";

import Box from "../Box";
import Modal from "../Modal";
import AddUserStep from "./Step/addUser";
import useStrings from "../../hooks/useStrings";
import AddOrganizationStep from "./Step/addOrganization";
import { ILableOrganization } from "../../commons/interfaces";

interface IProps {
    visibled: boolean;
    onClose: () => void;
    getUserLoginInformation: () => void;
}

const ModalManageOrganization = ({ visibled, lableOrganization, lableStaff, onClose, getUserLoginInformation }: IProps & ILableOrganization) => {
    const strings = useStrings();
    const [activeStep, setActiveStep] = useState<number>(0);
    const [addOrganizationIds, setAddOrganizationIds] = useState<string[]>([]);

    const handleAction = (activeStep: number, addOrganizationIds?: string[]) => {
        if (activeStep === 0) {
            setAddOrganizationIds(addOrganizationIds);
            if (addOrganizationIds.length === 0) return onClose();
            return setActiveStep(1);
        }
        return onClose();
    };

    const STEP_LABELS = useMemo(() => [
        strings.format(strings.Organization.ADD_ORGANIZATIONS, (lableOrganization || strings.Common.ORGANIZATION).toLowerCase()),
        strings.format(strings.Organization.ADD_STAFF, (lableStaff || strings.Common.STAFF).toLowerCase()),
    ], [strings, lableOrganization, lableStaff]);

    const renderTabContent = useCallback(
        (activeStep: number) => {
            switch (activeStep) {
                case 0:
                    return <AddOrganizationStep
                        onSubmit={handleAction} onClose={onClose}
                        getUserLoginInformation={getUserLoginInformation}
                    />;
                case 1:
                    return <AddUserStep
                        onClose={onClose}
                        addOrganizationIds={addOrganizationIds}
                    />;
                default:
                    return <></>;
            }
        },
        [activeStep]
    );

    return (
        <Modal
            fullWidth
            maxWidth="xs"
            visible={visibled}
            onClose={onClose}
            title={STEP_LABELS[activeStep]}
            buttonAction={activeStep === 0 ? strings.Common.NEXT : strings.Common.COMPLETE}
        >
            <Box>{renderTabContent(activeStep)}</Box>
        </Modal>
    );
};

export default ModalManageOrganization;
